import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import '../CSS/BlogPost.css';
import blogpostimage from '../assets/icons/slide1.jpg';
import { buildApiUrl, API_CONFIG } from '../config/api';

// Spinner component
const Spinner = () => (
    <div className="spinner-container">
        <div className="d-flex align-items-center">
            <div className="spinner-border text-white me-3" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mb-0">Loading blog post...</p>
        </div>
    </div>
);

function BlogPost() {
    const { id } = useParams();
    const [blogPost, setBlogPost] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (id) {
            fetchBlogPost();
        }
    }, [id]);

    const fetchBlogPost = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetch(buildApiUrl(API_CONFIG.ENDPOINTS.GET_POST, { id }));
            
            if (!response.ok) {
                throw new Error('Failed to fetch blog post');
            }
            
            const data = await response.json();
            setBlogPost(data);
        } catch (err) {
            console.error('Error fetching blog post:', err);
            setError('Failed to load blog post');
        } finally {
            setLoading(false);
        }
    };

    const handleRetry = () => {
        fetchBlogPost();
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('fi-FI', {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric'
        });
    };

    if (loading) {
        return (
            <div className="BlogPost container-fluid mt-3 mt-md-5 px-3 px-md-4">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-10 col-xl-8">
                        <Spinner />
                    </div>
                </div>
            </div>
        );
    }

    if (error || !blogPost) {
        return (
            <div className="BlogPost container-fluid mt-3 mt-md-5 px-3 px-md-4">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-10 col-xl-8">
                        <div className='header-section mb-4'>
                            <h1 className='header-name pb-3 pb-md-4 pt-2 pt-md-4 text-break'>Blog Post Not Found</h1>
                            <p className='subtext mb-3 text-break'>The blog post you're looking for doesn't exist.</p>
                            <div className="button-group">
                                <button 
                                    className="btn mb-3 mb-md-4"
                                    onClick={handleRetry}
                                >
                                    Retry
                                </button>
                                <Link to="/Blog" className="btn">Back to Blog</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div class="BlogPost container-fluid mt-5 mt-md-5 mb-1 px-4 px-md-5">
            <div className="row justify-content-center">
                <div className="col-12 col-lg-10 col-xl-8">

                    {/*Header section*/}
                    <div className='header-section mb-4'>
                        <h1 className='header-name pb-3 pb-md-4 pt-2 pt-md-4 text-break'>{blogPost.title}</h1>
                        <p className='subtext mb-1 text-break'>Written by {blogPost.author}</p>
                        <p className='articleDate mb-3 text-break'>Date: {formatDate(blogPost.created_at)}</p>
                        <Link to="/Blog" className="btn btn-secondary">Back to Blog</Link>
                    </div>

                    {/* Blog Post Content */}
                    <article className="blog-post">
                        <div 
                            dangerouslySetInnerHTML={{ __html: blogPost.content }}
                            className="blog-content text-break"
                        />
                    </article>
                </div>
            </div>
        </div>
    );
}

export default BlogPost;